import { Auth0Provider as BaseAuth0Provider } from '@auth0/auth0-react';
import { useNavigate } from 'react-router-dom';

interface Auth0ProviderProps {
  children: React.ReactNode;
}

export function Auth0ProviderWithNavigate({ children }: Auth0ProviderProps) {
  const navigate = useNavigate();

  const domain = import.meta.env.VITE_AUTH0_DOMAIN;
  const clientId = import.meta.env.VITE_AUTH0_CLIENT_ID;
  const audience = import.meta.env.VITE_AUTH0_AUDIENCE;

  const onRedirectCallback = (appState: any) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  if (!domain || !clientId) {
    console.error('Auth0 configuration missing:', {
      domain: domain ? '✓' : '✗',
      clientId: clientId ? '✓' : '✗',
      audience: audience ? '✓' : '✗',
    });
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>Error de configuración</h2>
        <p>Las variables de entorno de Auth0 no están configuradas correctamente.</p>
        <p style={{ fontSize: '0.9rem', color: '#666' }}>
          Domain: {domain || 'NO CONFIGURADO'}<br />
          Client ID: {clientId ? '✓' : 'NO CONFIGURADO'}
        </p>
      </div>
    );
  }

  // Validar formato del dominio de Auth0
  if (!domain.includes('.auth0.com') && !domain.includes('.auth0app.com')) {
    console.warn('Auth0 domain format may be incorrect:', domain);
  }

  const redirectUri = window.location.origin;
  
  // Log para debug (solo en desarrollo)
  if (import.meta.env.DEV) {
    console.log('Auth0 Configuration:', {
      domain,
      clientId: clientId?.substring(0, 8) + '...',
      redirectUri,
      audience,
    });
  }

  return (
    <BaseAuth0Provider
      domain={domain}
      clientId={clientId}
      authorizationParams={{
        redirect_uri: redirectUri,
        audience: audience,
        scope: 'openid profile email offline_access',
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
      useRefreshTokens={true}
    >
      {children}
    </BaseAuth0Provider>
  );
}
